<template>
    <basic-container>
        <div class="container">
            <ReCheck></ReCheck>
            <IndexNews></IndexNews>
        </div>
    </basic-container>
</template>

<script>
import ReCheck from "@/components/rcheck/index.vue"
import IndexNews from "./components/indexNews.vue"
export default {
    components: {
        ReCheck,IndexNews
    },
    name: "",
    data() {
        return {};
    },
    created() { },
};
</script>

<style lang="scss" scoped>
.container {
    padding: 20px 0;
}

@media screen and (max-width: 600px) {
    .container {
        padding: 20px;
    }
}
</style>